/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'arrows-right': {
    width: 284.936,
    height: 284.936,
    viewBox: '0 0 284.936 284.936',
    data: '<path pid="0" d="M277.515 135.9L144.464 2.857C142.565.955 140.375 0 137.9 0c-2.472 0-4.659.955-6.562 2.857l-14.277 14.275c-1.903 1.903-2.853 4.089-2.853 6.567 0 2.478.95 4.664 2.853 6.567L229.268 142.47 117.062 254.677c-1.903 1.903-2.853 4.093-2.853 6.564 0 2.477.95 4.667 2.853 6.57l14.277 14.271c1.902 1.905 4.089 2.854 6.562 2.854 2.478 0 4.665-.951 6.563-2.854l133.051-133.044c1.902-1.902 2.851-4.093 2.851-6.567s-.949-4.664-2.851-6.571z"/><path pid="1" d="M170.732 142.471c0-2.474-.947-4.665-2.857-6.571L34.833 2.857C32.931.955 30.741 0 28.267 0S23.602.955 21.7 2.857L7.426 17.133C5.52 19.036 4.57 21.222 4.57 23.7c0 2.478.95 4.664 2.856 6.567L119.63 142.471 7.426 254.677c-1.906 1.903-2.856 4.093-2.856 6.564 0 2.477.95 4.667 2.856 6.57l14.273 14.271c1.903 1.905 4.093 2.854 6.567 2.854s4.664-.951 6.567-2.854l133.042-133.044c1.91-1.902 2.857-4.093 2.857-6.567z"/>'
  }
})
